export default __webpack_public_path__ + "static/media/alcoholic.ae5ca97a.png";